import { render, staticRenderFns } from "./ItemCyclerItem.vue?vue&type=template&id=3c496060&scoped=true&"
import script from "./ItemCyclerItem.vue?vue&type=script&lang=ts&"
export * from "./ItemCyclerItem.vue?vue&type=script&lang=ts&"
import style0 from "./ItemCyclerItem.vue?vue&type=style&index=0&id=3c496060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c496060",
  null
  
)

export default component.exports